<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_placeholder_search') ||
                  '发运单付款结算单编号/发运单编号/外运编号/客户/结算方 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditPage', { pageType: 'add' })"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
            <el-badge :value="checkCount" class="item" v-if="allow('S')">
              <b-button
                size="sm"
                class="ml-2"
                variant="outline-success"
                @click="$emit('submitReview')"
                :disabled="!checkCount"
              >
                <!-- <b-icon-check></b-icon-check> -->
                {{ $l('btn_submitReview') || '提交审核' }}
              </b-button>
            </el-badge>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      show-close
      :modal-append-to-body="false"
      :modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="small">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_shipmentPayStatementStatus') || '账单状态'"
            >
              <dict-select
                v-model="form.listShipmentPayStatementStatus"
                url="/sys/common/dict/system"
                :body="{ dictType: 'shipmentPayStatementStatus' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('form_label_shipmentPayStatementNo') || '付款结算单编号'
              "
            >
              <el-input
                v-model.trim="form.shipmentPayStatementNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_shipmentNo') || '发运单编号'">
              <el-input
                v-model.trim="form.shipmentNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_shipmentContractNo') || '外运编号'"
            >
              <el-input
                v-model.trim="form.shipmentContractNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_customer') || '客户'">
              <dict-select
                v-model="form.listCustCode"
                url="/master/common/dict/customerSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_expenseCust') || '费用客户'">
              <dict-select
                v-model="form.listExpenseCustCode"
                url="/master/common/dict/customerSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_partyType') || '结算方类型'">
              <el-select
                v-model="form.listPayTo"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                multiple
                style="width:100%"
              >
                <el-option
                  value="F"
                  :label="$l('form_label_partyType_freightForwarder') || '货代'"
                ></el-option>
                <el-option
                  value="T"
                  :label="
                    $l('form_label_partyType_transportationCompany') ||
                      '运输公司'
                  "
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_isAppend') || '是否为追加费用'"
            >
              <el-select
                v-model="form.listIsAppend"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                multiple
                style="width:100%"
              >
                <el-option
                  value="Y"
                  :label="$l('INDEX.YES') || '是'"
                ></el-option>
                <el-option
                  value="N"
                  :label="$l('INDEX.NO') || '否'"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_party') || '结算方'">
              <dict-select
                v-model="form.listPayScmCode"
                url="/master/common/dict/allScmCooperated"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_payer') || '付款方'">
              <dict-select
                v-model="form.listPayerCode"
                url="/master/common/dict/biz"
                :body="expensePayerParams"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_payScmBankName') || '开户银行'"
            >
              <el-input
                v-model.trim="form.bankName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_payScmBankAccountName') || '账户名称'"
            >
              <el-input
                v-model.trim="form.bankAccountName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_payScmBankAccountNo') || '银行账号'"
            >
              <el-input
                v-model.trim="form.bankAccountNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_payScmBankAccountType') || '账户性质'"
            >
              <el-select
                v-model="form.listBankAccountType"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                filterable
                clearable
                multiple
                style="width:100%"
              >
                <el-option
                  v-for="item in bankAccountOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_payScmBankAccountKind') || '账号类别'"
            >
              <dict-select
                v-model="form.listBankAccountKind"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                :body="bankAccountKindParams"
                url="/master/common/dict/biz"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_paymentMethod') || '付款方式'">
              <dict-select
                v-model="form.listPaymentMethod"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                :body="paymentMethodParams"
                url="/master/common/dict/biz"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_currencyUnit') || '货币单位'">
              <dict-select
                v-model="form.listCurrencyUnit"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                :body="bankAccountKindParams"
                url="/master/common/dict/biz"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('form_label_currencyTotalAmount') || '费用合计'"
              >
                <br />
                <el-col :span="11">
                  <el-input-number
                    v-model="form.currencyTotalAmountStart"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.currencyTotalAmountEnd"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                  ></el-input-number>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row>
              <el-form-item :label="$l('INDEX.create_date') || '创建时间'">
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = {
  keyword: '',
  listShipmentPayStatementStatus: ['W', 'S', 'R', 'Y'],
}
export default {
  props: { checkCount: { type: Number, default: 0 } },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      expensePayerParams: { dictType: 'expensePayer' },
      bankAccountKindParams: { dictType: 'bankAccountKind' },
      paymentMethodParams: { dictType: 'paymentMethod' },
      bankAccountOptions: [
        {
          label: this.$l('INDEX.form_label_company') || '公司',
          value: '0',
        },
        {
          label: this.$l('INDEX.form_label_personal') || '个人',
          value: '1',
        },
      ],
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
